import React, { useState, useEffect } from 'react';
import TransactionApi from '../api/TransactionApi';
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import { GiExpense, GiProfit } from "react-icons/gi";
import AccountApi from '../api/AccountApi';
import { MdAccountBalance } from 'react-icons/md';
import PieChart from '../component/chart/PieChart';
import LineChart from '../component/chart/LineChart';

const Dashboard = () => {
  const [balance, setBalance] = useState('');
  const [totalIncome, setTotalIncome] = useState(0);
  const [totalExpense, setTotalExpense] = useState(0);
  const [totalProfit, setTotalProfit] = useState(0);
  const [incomeLabels, setIncomeLabels] = useState([]);
  const [incomeSeries, setIncomeSeries] = useState([]);
  const [expenseLabels, setExpenseLabels] = useState([]);
  const [expenseSeries, setExpenseSeries] = useState([]);

  useEffect(() => {
    getTransaction();
    getAccount();
  }, []);

  const getTransaction = async () => {
    try {
      const res = await TransactionApi.incomes();
      const transactions = res;

      let income = 0;
      let expense = 0;
      let profit = 0;
      const incomeData = {};
      const expenseData = {};
      
      transactions.forEach((transaction) => {
        const amount = parseFloat(transaction.amount); 
        const categoryName = transaction.cat_name || 'Uncategorized';
        
        if (transaction.type === 'income') {
          income += amount;
          if (!incomeData[categoryName]) {
            incomeData[categoryName] = 0;
          }
          incomeData[categoryName] += amount;
        } else if (transaction.type === 'expense') {
          expense += amount;
          if (!expenseData[categoryName]) {
            expenseData[categoryName] = 0;
          }
          expenseData[categoryName] += amount;
        }
      });

      profit = income - expense;
      setTotalProfit(profit);
      setTotalIncome(income);
      setTotalExpense(expense);
      setIncomeLabels(Object.keys(incomeData));
      setIncomeSeries(Object.values(incomeData));
      setExpenseLabels(Object.keys(expenseData));
      setExpenseSeries(Object.values(expenseData));
    } catch (error) {
      console.error('Error fetching transactions:', error);
    }
  };
 
  const getAccount = async () => {
    try {
      const res = await AccountApi.index();
      if (Array.isArray(res)) {
        const balances = res.map((account) => parseFloat(account.current_balance) || 0);
        const total = balances.reduce((acc, balance) => acc + balance);
        // console.log(total);
        setBalance(total);
      } else {
        console.error('Unexpected response format');
      }
    } catch (error) {
      console.error('Error fetching accounts:', error);
    }
  };

  return (
    <>
      <div className="bg-white px-6 py-4 border-b">
      <div className="text-lg text-gray-500">
        <h1>Dashboard</h1>
      </div>
    </div>
     
      <div className='grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4'>
          <div className="relative overflow-hidden rounded-lg bg-gray-600 px-4 pt-5 shadow sm:px-6 sm:pt-6">
            <dt>
              <div className="absolute rounded-md bg-white p-3 text-2xl">
                  <FaMoneyBillTrendUp />
              </div>
              <p className="ml-16 truncate text-sm font-medium text-gray-300">Total Income</p>
            </dt>
            <dd className="ml-16 flex items-baseline pb-6 sm:pb-7">
              <p className="text-xl lg:text-2xl font-semibold text-gray-100">${Number(totalIncome).toFixed(2)}</p>
            </dd>
          </div>

          <div className="relative overflow-hidden rounded-lg bg-gray-600 px-4 pt-5 shadow sm:px-6 sm:pt-6">
            <dt>
              <div className="absolute rounded-md bg-white p-3 text-2xl">
                  <GiExpense />
              </div>
              <p className="ml-16 truncate text-sm font-medium text-gray-300">Total Expense</p>
            </dt>
            <dd className="ml-16 flex items-baseline pb-6 sm:pb-7">
              <p className="text-xl lg:text-2xl font-semibold text-gray-100">${Number(totalExpense).toFixed(2)}</p>
            </dd>
          </div>

          <div className="relative overflow-hidden rounded-lg bg-gray-600 px-4 pt-5 shadow sm:px-6 sm:pt-6">
            <dt>
              <div className="absolute rounded-md bg-white p-3 text-2xl">
                  <GiProfit />
              </div>
              <p className="ml-16 truncate text-sm font-medium text-gray-300">Profit</p>
            </dt>
            <dd className="ml-16 flex items-baseline pb-6 sm:pb-7">
              <p className="text-xl lg:text-2xl font-semibold text-gray-100">${Number(totalProfit).toFixed(2)}</p>
            </dd>
          </div>

          <div className="relative overflow-hidden rounded-lg bg-gray-600 px-4 pt-5 shadow sm:px-6 sm:pt-6">
            <dt>
              <div className="absolute rounded-md bg-white p-3 text-2xl">
                  <MdAccountBalance />
              </div>
              <p className="ml-16 truncate text-sm font-medium text-gray-300">Balance</p>
            </dt>
            <dd className="ml-16 flex items-baseline pb-6 sm:pb-7">
              <p className="text-xl lg:text-2xl font-semibold text-gray-100">${Number(balance).toFixed(2)}</p>
            </dd>
          </div>
      </div>

 
      <div className='grid grid-cols-10 mt-8 gap-3'>
        <div className='col-span-7 bg-gray-50 rounded-lg p-4'>
          <LineChart />
        </div>
        <div className='col-span-3 grid grid-cols-1 gap-3'>
          <div className='bg-gray-50 rounded-lg p-4'>
            <PieChart getLabels={incomeLabels} getSeries={incomeSeries} name='Income'/>
          </div>
          <div className='bg-gray-50 rounded-lg p-4'>
            <PieChart getLabels={expenseLabels} getSeries={expenseSeries} name='Expense'/>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
